import script from "./DesiredEditView.vue?vue&type=script&lang=ts&setup=true"
export * from "./DesiredEditView.vue?vue&type=script&lang=ts&setup=true"

import "./DesiredEditView.vue?vue&type=style&index=0&id=dcccb196&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/jobs/MASSMEDIAN_MYPAGE_VIEW_PROD/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dcccb196"]])

export default __exports__